import { JSX } from 'react';
const map = {
    "m/s2": <>m/s<sup>2</sup></>,
    "nm2": <>nm<sup>2</sup></>,
    "μm2": <>μm<sup>2</sup></>,
    "mm2": <>mm<sup>2</sup></>,
    "cm2": <>cm<sup>2</sup></>,
    "dm2": <>dm<sup>2</sup></>,
    "m2": <>m<sup>2</sup></>,
    "km2": <>km<sup>2</sup></>,
    "in2": <>in<sup>2</sup></>,
    "yd2": <>yd<sup>2</sup></>,
    "ft2": <>ft<sup>2</sup></>,
    "mi2": <>mi<sup>2</sup></>,
    "mH2O": <>mH<sub>2</sub>O</>,
    "mm3": <>mm<sup>3</sup></>,
    "cm3": <>cm<sup>3</sup></>,
    "dm3": <>dm<sup>3</sup></>,
    "m3": <>m<sup>3</sup></>,
    "km3": <>km<sup>3</sup></>,
    "in3": <>in<sup>3</sup></>,
    "ft3": <>ft<sup>3</sup></>,
    "yd3": <>yd<sup>3</sup></>,
    "mm3/s": <>mm<sup>3</sup>/s</>,
    "cm3/s": <>cm<sup>3</sup>/s</>,
    "dm3/s": <>dm<sup>3</sup>/s</>,
    "dm3/min": <>dm<sup>3</sup>/min</>,
    "dm3/h": <>dm<sup>3</sup>/h</>,
    "dm3/d": <>dm<sup>3</sup>/d</>,
    "dm3/a": <>dm<sup>3</sup>/a</>,
    "m3/s": <>m<sup>3</sup>/s</>,
    "m3/min": <>m<sup>3</sup>/min</>,
    "m3/h": <>m<sup>3</sup>/h</>,
    "m3/d": <>m<sup>3</sup>/d</>,
    "m3/a": <>m<sup>3</sup>/a</>,
    "km3/s": <>km<sup>3</sup>/s</>,
    "in3/s": <>in<sup>3</sup>/s</>,
    "in3/min": <>in<sup>3</sup>/min</>,
    "in3/h": <>in<sup>3</sup>/h</>,
    "ft3/s": <>ft<sup>3</sup>/s</>,
    "ft3/min": <>ft<sup>3</sup>/min</>,
    "ft3/h": <>ft<sup>3</sup>/h</>,
    "yd3/s": <>yd<sup>3</sup>/s</>,
    "yd3/min": <>yd<sup>3</sup>/min</>,
    "yd3/h": <>yd<sup>3</sup>/h</>
}

/**
 * This method convert regular m2 to m<sup>2</sup> for better HTML UX
 * @param abbr 
 * @returns 
 */
export function unitFormatter(abbr: string): JSX.Element {
    return map[abbr] || abbr
}

interface UnitConversionFormatterArgument {
     readableFromPlural: string;
     readableToPlural: string;
      readableFromAbbr: string;
     readableToAbbr: string;
    }
export function unitConversionFormatter(args: UnitConversionFormatterArgument) {
    return <>{args.readableFromPlural} to {args.readableToPlural} ({unitFormatter(args.readableFromAbbr)} to {unitFormatter(args.readableToAbbr)})</>

}